import React from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'

import IntegrationsLayout from 'pages/Admin/Integrations/Layout'
import ZendeskFeedbackImport from 'pages/Admin/Integrations/ZendeskFeedbackImport'
import { InfusionsoftIntegrationContainer } from 'organisms/InfusionsoftIntegration/container'
import DropboxIntegrationSubPageContainer from 'pages/Admin/Integrations/Dropbox/container'
import WebhookIntegrationContainer from 'organisms/WebhookIntegration/container'
import GlobalIntercomIntegrationContainer from 'organisms/GlobalIntercomIntegration/container'
import CyclrMarketplacePage from 'pages/Admin/Integrations/Cyclr/Marketplace'
import EmbeddingCyclrIntegrationPage from 'pages/Admin/Integrations/Cyclr/Embedding'
import AdminIntegrationIndexPage from 'pages/Admin/Integrations/Index'
import PermissionRoute from 'domains/routes/PermissionRoute'
import constants from 'config/constants'

const Routes = () => (
  <IntegrationsLayout>
    <Switch>
      <Route
        path="/:workspaceToken/settings/integrations/"
        exact
        component={AdminIntegrationIndexPage}
      />
      <PermissionRoute
        permission={constants.permissions.manageIntegrations}
        path="/:workspaceToken/settings/integrations/zendesk-satisfaction-rating/"
        component={ZendeskFeedbackImport}
      />
      <PermissionRoute
        permission={constants.permissions.manageIntegrations}
        path="/:workspaceToken/settings/integrations/dropbox/"
        component={DropboxIntegrationSubPageContainer}
      />
      <PermissionRoute
        permission={constants.permissions.manageIntegrations}
        path="/:workspaceToken/settings/integrations/infusionsoft/"
        component={InfusionsoftIntegrationContainer}
      />
      <PermissionRoute
        permission={constants.permissions.manageIntegrations}
        path="/:workspaceToken/settings/integrations/intercom/"
        component={GlobalIntercomIntegrationContainer}
      />
      <PermissionRoute
        permission={constants.permissions.manageIntegrations}
        path="/:workspaceToken/settings/integrations/slack/"
        component={() => <WebhookIntegrationContainer type="slack" />}
      />
      <PermissionRoute
        permission={constants.permissions.manageIntegrations}
        path="/:workspaceToken/settings/integrations/microsoft-teams/"
        component={() => <WebhookIntegrationContainer type="microsoft_teams" />}
      />
      <PermissionRoute
        permission={constants.permissions.manageIntegrations}
        path="/:workspaceToken/settings/integrations/beta/"
        component={CyclrMarketplacePage}
      />
      <PermissionRoute
        permission={constants.permissions.manageIntegrations}
        path="/:workspaceToken/settings/integrations/:connectorId/"
        component={EmbeddingCyclrIntegrationPage}
      />
      <Route render={() => <Redirect to="/404/" />} />
    </Switch>
  </IntegrationsLayout>
)

export default Routes



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Integrations/Routes.js